<script setup>
import { BUSINESS_PERMISSIONS } from "@/constants/businessAccess"

const route = useRoute()
const { can } = useBusinessAccess()
const items = [
  { title: "داشبورد", icon: "tabler-layout-dashboard", to: "/user-profile/company-settings", permission: BUSINESS_PERMISSIONS.DASHBOARD_VIEW, exact: true },
  { title: "نوبت‌ها", icon: "tabler-calendar-event", to: "/user-profile/company-settings/appointment", permission: BUSINESS_PERMISSIONS.RESERVATION_MANAGE },
  { title: "خدمات", icon: "tabler-sparkles", to: "/user-profile/company-settings/service", permission: BUSINESS_PERMISSIONS.SERVICE_MANAGE },
  { title: "اپ مشتری", icon: "tabler-device-mobile", to: "/client-page", public: true },
]
const visibleItems = computed(() =>
  items.filter(item => item.public || can(item.permission))
)
const active = item => item.exact ? route.path === item.to : route.path.startsWith(item.to.split("#")[0])
</script>

<template>
  <nav class="business-mobile-nav" aria-label="منوی سریع مدیریت">
    <NuxtLink v-for="item in visibleItems" :key="item.title" :to="item.to" :class="{ 'is-active': active(item), 'is-client-app': item.public }">
      <VIcon :icon="item.icon" size="21" /><span>{{ item.title }}</span>
    </NuxtLink>
  </nav>
</template>

<style scoped lang="scss">
.business-mobile-nav { position: fixed; z-index: 40; right: 8px; bottom: 8px; left: 8px; display: none; grid-template-columns: repeat(4,1fr); min-height: 62px; padding: 6px; border: 1px solid rgba(43,37,69,.09); border-radius: 19px; background: rgba(255,255,255,.96); box-shadow: 0 12px 35px rgba(35,29,62,.14); backdrop-filter: blur(16px); }
.business-mobile-nav a { display: grid; place-items: center; align-content: center; gap: 3px; border-radius: 13px; color: #817b8e; font-size: 8px; }
.business-mobile-nav a.is-active { color: rgb(var(--v-theme-primary)); background: rgba(var(--v-theme-primary),.08); font-weight: 800; }
.business-mobile-nav a.is-client-app { color: #625a72; }
.business-mobile-nav a.is-client-app:hover { color: rgb(var(--v-theme-primary)); background: rgba(var(--v-theme-primary),.06); }
@media (max-width: 959px) { .business-mobile-nav { display: grid; } }
</style>
